const GET_CHARGES_REQUEST = 'GET_CHARGES_REQUEST';
const GET_CHARGE_REQUEST = 'GET_CHARGE_REQUEST';
const CREATE_CHARGE_REQUEST = 'CREATE_CHARGE_REQUEST';
const UPDATE_CHARGE_REQUEST = 'UPDATE_CHARGE_REQUEST';
const DELETE_CHARGE_REQUEST = 'DELETE_CHARGE_REQUEST';
const ACTIVATE_CHARGE_REQUEST = 'ACTIVATE_CHARGE_REQUEST';
const DEACTIVATE_CHARGE_REQUEST = 'DEACTIVATE_CHARGE_REQUEST';


export const getCharges = (callback) => {
    return {
        type: GET_CHARGES_REQUEST,
        payload: { callback }
    }
}

export const getCharge = (id, callback) => {
    return {
        type: GET_CHARGE_REQUEST,
        payload: { id, callback }
    }
}

export const createCharge = (charge, callback) => {
    return {
        type: CREATE_CHARGE_REQUEST,
        payload: { charge, callback }
    }
}

export const updateCharge = (id, charge, callback) => {
    return {
        type: UPDATE_CHARGE_REQUEST,
        payload: { id, charge, callback }
    }
}

export const deleteCharge = (id, callback) => {
    return {
        type: DELETE_CHARGE_REQUEST,
        payload: { id, callback }
    }
}

export const activateCharge = (id, callback) => {
    return {
        type: ACTIVATE_CHARGE_REQUEST,
        payload: { id, callback }
    }
}

export const deactivateCharge = (id, callback) => {
    return {
        type: DEACTIVATE_CHARGE_REQUEST,
        payload: { id, callback }
    }
}
